import React, { useState } from "react";
import { Link } from "react-router-dom";
import Search from "../search/Search";
import DownBar from "./DownBar";

const TopBar = () => {
  // const [showNav, setShowNav] = useState(false);

  // const NavToggleHandler = () => {
  //   setShowNav(!showNav);
  // };

  const navItem = [
    { name: "Home", id: 1, url: "/" },
    { name: "All Products", id: 2, url: "/products" },
    { name: "Laptop", id: 2, url: "/laptop" },
    { name: "Mobile", id: 3, url: "" },
    { name: "Desktop", id: 4, url: "" },
    { name: "Blogs", id: 4, url: "" },
  ];

  return (
    <>
      <div className="Navbar z-50 sticky top-0 px-[10px] md:px-[20px] lg:px-[3%] bg-[#081621]s bg-slate-800 flex flex-row justify-between h-16 items-center pl-2">
        <div className="md:px-0 flex-1 flex flex-row ">
          <Link
            className="text-white uppercase text-xl font-bold whitespace-nowrap "
            to="/"
          >
            WASI STORE
          </Link>
          <Search />
        </div>
        <div className="text-black flex flex-row md:relative">
          <div className="hidden md:flex flex-row">
            <DownBar navItems={navItem} /> {/* Pass navItems as a prop */}
          </div>
        </div>
      </div>

      {
        <div className="md:hidden fixed bottom-0 w-[100%] md:w-fit h-14 bg-white flex justify-between items-center rounded-t-2xl text-2xl z-20 ">
          <DownBar navItems={navItem} /> {/* Pass navItems as a prop */}
        </div>
      }
    </>
  );
};

export default TopBar;
